import { format as dateFnsFormat } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

interface TimestampDisplayProps {
  date: string | Date;
  showSeconds?: boolean;
  className?: string;
}

export function TimestampDisplay({
  date,
  showSeconds = true,
  className = '',
}: TimestampDisplayProps) {
  const formatTimestamp = () => {
    try {
      // Get user's timezone from browser
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Parse the input date (assumes it's in UTC if it's a string)
      const dateObj = typeof date === 'string' ? new Date(date) : date;

      // Check if date is valid
      if (Number.isNaN(dateObj.getTime())) {
        throw new Error('Invalid date input');
      }

      // Format pattern with UTC offset
      const pattern = showSeconds ? 'MMM dd, yyyy HH:mm:ss XXX' : 'MMM dd, yyyy HH:mm XXX';

      // Use formatInTimeZone to handle the conversion and formatting in one step
      return formatInTimeZone(dateObj, userTimezone, pattern);
    } catch (_error) {
      // Fallback to UTC if timezone detection fails
      try {
        const dateObj = typeof date === 'string' ? new Date(date) : date;

        // Check if date is valid
        if (Number.isNaN(dateObj.getTime())) {
          return 'Invalid date';
        }

        const pattern = showSeconds ? "MMM dd, yyyy HH:mm:ss 'UTC'" : "MMM dd, yyyy HH:mm 'UTC'";

        // Use regular date-fns format for UTC
        return dateFnsFormat(dateObj, pattern);
      } catch {
        // Last resort fallback
        return 'Invalid date';
      }
    }
  };

  return <span className={className}>{formatTimestamp()}</span>;
}
